import { FlowNodeTypes } from '../types'
import { AI_NODE_TYPES } from './panel.config'

// Never on a Flow canvas: the palette's AI section, the types it expands to on the wire, and
// the older AI node types.
const FLOW_BLOCKED_NODE_TYPES: ReadonlySet<string> = new Set<string>([
  ...AI_NODE_TYPES,
  FlowNodeTypes.ai_skills,
  FlowNodeTypes.contact_screening,
  FlowNodeTypes.ai_agent_call,
  FlowNodeTypes.ai_agent_message,
  FlowNodeTypes.ai_agent_chat,
  FlowNodeTypes.ai_agent_whatsapp,
  FlowNodeTypes.ai_assist,
  // A legacy node type that only appears in saved builds.
  'ai_chatbot',
])

export const isFlowBlockedNode = (type?: string) => !!type && FLOW_BLOCKED_NODE_TYPES.has(type)

export const withoutFlowBlockedNodes = <N extends { type?: string }>(nodes: N[]) =>
  nodes.filter((node) => !isFlowBlockedNode(node.type))
